import { render, staticRenderFns } from "./ServiciosDecesosPremium.vue?vue&type=template&id=1311da7e&scoped=true&"
var script = {}
import style0 from "./ServiciosDecesosPremium.vue?vue&type=style&index=0&id=1311da7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311da7e",
  null
  
)

export default component.exports